var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("Posts in a Draft Stage")]),_c('postCardList',{attrs:{"posts":_vm.posts,"seller":true,"loading":_vm.loading,"defaultSort":"Created Date","showSort":true,"sortByOptions":[
			'Created Date',
			'Reference',
			'Turnover',
			'Heading'
		]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }